import { render, staticRenderFns } from "./TheSizesFilter.vue?vue&type=template&id=e7165158&"
import script from "./TheSizesFilter.vue?vue&type=script&lang=js&"
export * from "./TheSizesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports